import { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import routes from "./routes";
import { AppSingleton } from "../services/user_config";
import { NewsAvatar } from "../components/news-avatar";
import { NewsMarquee } from "../components/news-marquee";

const ContainerDrawer = () => {
  const navigate = useNavigate();
  var appSingleton = new AppSingleton();
  appSingleton.navigate = navigate;

  return (
    <>
      <Box sx={{ mt: 8 }}>
        {/* <Grid
          sx={{
            // background: "transparent",
            position: "fixed",
            right: 32,
            bottom: 64,
            zIndex: 99,
          }}
        >
          <NewsAvatar />
        </Grid> */}
        <Grid
          sx={{
            // background: "transparent",
            position: "fixed",
            width: "100%",
            bottom: 0,
            zIndex: 99,
          }}
        >
          <NewsMarquee height={64} />
        </Grid>
        <Routes>
          {routes.map(({ name, key, icon, route, component }) => (
            <Route key={key} path={route} element={component}></Route>
          ))}
        </Routes>
      </Box>
    </>
  );
};

export { ContainerDrawer };
